import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import GameModes from "./components/GameModes";
import Rules from "./components/Rules";
import Features from "./components/Features";
import Footer from "./components/Footer";
import "./styles/globals.css";

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black-face to-black text-white">
      <Header />
      <main>
        <Hero />
        <GameModes />
        <Rules />
        <Features />
      </main>
      <Footer />
    </div>
  );
};

export default App;
